import { registerPlugin } from "@capacitor/core";

export interface SecureStoragePlugin {
  enqueue(options: { id: string; payload: string }): Promise<void>;
  list(): Promise<{ items: Array<{ id: string; payload: string; queuedAt: string }> }>;
  remove(options: { id: string }): Promise<void>;
  putDraft(options: { ownerId: string; payload: string }): Promise<void>;
  getDraft(options: { ownerId: string }): Promise<{ payload?: string }>;
  removeDraft(options: { ownerId: string }): Promise<void>;
}

export const SecureStorage = registerPlugin<SecureStoragePlugin>("SecureOutbox");
